import React from 'react';

//CSS File
import './example.css';

const Example = () => {

    return (

        <section className='examples'>

            <div className='examples-content'>

                <h1>Noteworthy <span>Examples</span></h1>

                <p>Enhance your team's efficiency with a swift AI assistant creation process. In mere minutes, craft an AI companion seamlessly collaborating with your entire team.</p>

            </div>

        </section>

    )

}

export default Example;